// extracted by mini-css-extract-plugin
export default {"paymentLinkContainer":"PaymentLink_paymentLinkContainer__zEo8-","paymentLink":"PaymentLink_paymentLink__NZlOI"};